module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAS1BMVEUAksfqBDf82eD////4pbjtI1D3n7LrDj/0d5P3mq7rCjzyZoXsHEr5tsX5vcrrFUTwSG3vQGf2lar+9vj7ytX5ssLza4nxVngArmg+9RSyAAAAzklEQVR4Ae3WCQrCQAyFYeuzxo7WLlr1/ieVhgqOjGwmAfV9rGX7CZ1tRb+EiIiIiIgqf//XWGOx8Wog49GosdjK/LmDfaOBQnqqGjf2UAfHfy5QrusKqi7EzRrt2zGOYtWA6gozaLiXzxtdeQygFWAY0RjMccLsXFwIGjdoQPXltmmjejVhcfFqIJMi5wj4HwHrymF/TAIMDUa/fZ4e+/ya4s+r+HM3/v6IvwfD7/OAd4lC5lvfiYrv9pu/qAYbbLDBBhtssMEGG2ywwcYdgXxD+dyS/dYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Azerbaijan.png
// module id = 558
// module chunks = 0